/**
 * 金額・数値入力で全角数字などを半角に寄せる（IME・コピペ対策）。
 * ０-９（U+FF10–FF19）、全角小数点（U+FF0E）、全角／長音符マイナス（U+FF0D, U+2212）を変換する。
 */
export function normalizeFullWidthNumerics(input: string): string {
  if (!input) return input;
  return input
    .replace(/[\uFF10-\uFF19]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xff10 + 0x30))
    .replace(/\uFF0E/g, '.')
    .replace(/[\u2212\uFF0D]/g, '-');
}
